
































































































































































































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { AxiosVue } from '@/AxiosVue';
import { fetchMS } from './fetchMS';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { actionsEvent } from '@/setup';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import Confirmation from '@/components/Confirmation.vue';
import { LoadingService } from '@/services/loadingService';
import moment from 'moment';
import modalVerDetalleCuadratura from '@/pantallas/Conecta/Cuadraturas/ModalVerDetalleCuadratura.vue';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';

@Component({
  components: {
    MantenedorGridSinCodigo,
    DatePicker,
    modalVerDetalleCuadratura,
    'app-confirmacion': Confirmation,
  },
})
export default class ConectaCuadraturas extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.conecta_cuadraturas;
  CUADRATURA_SELECCIONADA: any = null;
  NUMERO_SOLICITUD_SELECCIONADA: any = null;
  gridApi: GridApi = null;
  ModalDetalleCuadra: boolean = false; //controla el estado del modal
  LISTA_CUADRATURAS: any = [];
  model_filtro_inicio: any = null;
  model_filtro_fin: any = null;
  model_filtro_patente: any = null;
  filtro_patente: any = null;
  model_filtro_tecnico: any = null;
  filtro_tecnico: any = null;
  model_filtro_serie: any = null;
  filtro_serie: any = null;
  model_filtro_finalizado: any = null;
  filtro_finalizado: { idFinalizado: string; label: string }[] = [
    { idFinalizado: 'f', label: 'Pendiente' },
    { idFinalizado: 't', label: 'Finalizado' },
  ];
  model_filtro_cliente: any = null;
  filtro_cliente: any = null;
  mostrarModalCONFIRMAR: boolean = false;
  Modal_confirmar_TEXTO: any = '';

  showReporteGenerado: boolean = false;
  texto_reporte: string = 'TEXTO CUERPO MODAL';

  accionVerDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionVerDetalle];

  gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Número Cuadratura',
        field: 'Número Cuadratura',
        hide: true,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Nro Solicitud',
        field: 'Nro Solicitud',
        hide: false,
        width: 150,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha Solicitud',
        field: 'Fecha Solicitud',
        hide: false,
        width: 150,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Patente',
        field: 'Patente',
        hide: false,
        width: 130,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Técnico',
        field: 'Técnico',
        hide: false,
        width: 170,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Cliente',
        field: 'Cliente',
        hide: false,
        width: 350,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'EPC Finalizados / Totales',
        field: 'cantidadEpc',
        cellStyle: { textAling: 'center' },
        resizable: true,
        width: 200,
      },
      {
        headerName: 'Estado',
        field: 'Finalizado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Mapa',
        field: 'mapa',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 100,
        cellRenderer: this.getHtml_toGoogleMaps,
      },
    ],
    pagination: true,
    paginationPageSize: 30,
    onGridReady: this.handleGridReady,
  };

  constructor() {
    super();
    this.actions()
  }
  handlerbuttonmodalFinalizar(params: ICellRendererParams) {
    this.CUADRATURA_SELECCIONADA = params.data['Número Cuadratura'];
    this.NUMERO_SOLICITUD_SELECCIONADA = params.data['Nro Solicitud'];
    this.Modal_confirmar_TEXTO =
      '¿Está seguro que desea devolver Finalizar orden ' +
      this.NUMERO_SOLICITUD_SELECCIONADA +
      ' ?';
    this.mostrarModalCONFIRMAR = true;
  }
  handlerbuttonmodalVerDetalle(params: ICellRendererParams) {
    this.CUADRATURA_SELECCIONADA = params.data['Número Cuadratura'];
    this.NUMERO_SOLICITUD_SELECCIONADA = params.data['Nro Solicitud'];
    this.ModalDetalleCuadra = true;
  }

  ModalDetalleCuadra_callback(event: any) {
    actionsEvent.removeListeners();
    this.actions();
    this.ModalDetalleCuadra = event;
  }
  actions() {
    actionsEvent.onVerDetalle(this.handlerbuttonmodalVerDetalle);
  }
  async handleGridReady(event: GridReadyEvent) {
    this.LISTA_CUADRATURAS = await this.get_grid_listas_cuadraturas();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.LISTA_CUADRATURAS);
    this.gridApi.setDomLayout('autoHeight');
    this.model_filtro_inicio = moment(new Date()).subtract(1, 'months');
    this.model_filtro_fin = moment(new Date());
  }

  async cleanfilters() {
    this.model_filtro_inicio = moment(new Date()).subtract(1, 'months');
    this.model_filtro_fin = moment(new Date());
    this.model_filtro_patente = null;
    this.model_filtro_inicio = null;
    this.model_filtro_fin = null;
    this.model_filtro_finalizado = null;
    this.model_filtro_tecnico = null;
    this.LISTA_CUADRATURAS = await this.get_grid_listas_cuadraturas();
    this.gridApi.setRowData(this.LISTA_CUADRATURAS);
  }

  async confirmCallback(val: boolean) {
    if (val == true) {
      this.mostrarModalCONFIRMAR = false;
      this.loadingService.showLoading(undefined, 'finalizar_solicitud');
      return fetchMS(
        {
          id_cliente: this.getCliente(),
          id_usuario: this.getUserID(),
          modulo_id: 265,
          id_cuadratura: this.CUADRATURA_SELECCIONADA,
          id_solicitud: this.NUMERO_SOLICITUD_SELECCIONADA,
        },
        'finalizar_solicitud'
      )
        .then((data: any) => {
          this.loadingService.hideLoading('finalizar_solicitud');
          if (Number(data.data.CODIGO_RESPUESTA) > 1) {
            this.$snotify.error(data.data.MENSAJE_RESPUESTA);
          } else {
            this.$snotify.success(data.data.MENSAJE_RESPUESTA);
          }
        })
        .catch((error: any) => {
          this.loadingService.hideLoading('finalizar_solicitud');
          return null;
        })
        .finally(() => {
          return null;
          this.loadingService.hideLoading('finalizar_solicitud');
        });
    } else {
      this.mostrarModalCONFIRMAR = false;
    }
  }

  async applyfilters() {
    let body: { [key: string]: string } = {
      filtro_patente: this.model_filtro_patente,
      filtro_inicio: this.model_filtro_inicio,
      filtro_fin: this.model_filtro_fin,
      filtro_finalizado: this.model_filtro_finalizado,
      filtro_tecnico: this.model_filtro_tecnico,
      filtro_cliente: this.model_filtro_cliente,
      filtro_serie: this.model_filtro_serie,
    };
    this.LISTA_CUADRATURAS = await this.get_grid_listas_cuadraturas(body);
    this.gridApi.setRowData(this.LISTA_CUADRATURAS);
  }

  async get_grid_listas_cuadraturas(filter_data: any = null) {
    if (filter_data == null) {
      //aplico por defecto el filtro que da un mes en base al campo fecha_creacion
      filter_data = {
        filtro_inicio: moment(new Date()).subtract(1, 'months'),
        filtro_fin: moment(new Date()),
      };
    }
    this.loadingService.showLoading(undefined, 'get_grid_data_cuadraturas');

    return fetchMS(filter_data, 'inicio')
      .then((data: any) => {
        this.loadingService.hideLoading('get_grid_data_cuadraturas');
        this.filtro_patente = data.data.FILTROS.PATENTES.LISTA;
        this.filtro_serie = data.data.FILTROS.SERIES.LISTA;
        this.filtro_tecnico = data.data.FILTROS.TECNICOS.LISTA;
        this.filtro_cliente = data.data.FILTROS.CLIENTES.LISTA;
        return data.data.data.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  } //end get_grid_listas_cuadraturas

  getHtml_Existencia(params: any): string {
    if (params.data.Existencia == 'f') {
      return '<i class="material-icons"  title="false" style="width: 24px; height: 24px; margin-top: 7%; background: #FF2626; border-radius: 50%;" ></i>';
    } else {
      return '<i class="material-icons" title="true" style="width: 24px; height: 24px; margin-top: 7%; background: #26FF26; border-radius: 50%;" ></i>';
    }
    return '';
  }
  getHtml_validado(params: any): string {
    if (params.data.Validado == 'f') {
      return '<i class="material-icons"  title="false" style="width: 24px; height: 24px; margin-top: 7%; background: #FF2626; border-radius: 50%;" ></i>';
    } else {
      return '<i class="material-icons" title="true" style="width: 24px; height: 24px; margin-top: 7%; background: #26FF26; border-radius: 50%;" ></i>';
    }
    return '';
  }

  getHtml_Finalizado(params: any): string {
    if (params.data.Finalizado == 'f') {
      return '<i class="material-icons"  title="false" style="width: 24px; height: 24px; margin-top: 7%; background: #FF2626; border-radius: 50%;" ></i>';
    } else {
      return '<i class="material-icons" title="true" style="width: 24px; height: 24px; margin-top: 7%; background: #26FF26; border-radius: 50%;" ></i>';
    }
    return '';
  }

  getHtml_toGoogleMaps(params: any): string {
    let urlmapa = params.data.mapa;
    return `<i aria-hidden="true" class="v-icon importExportBtnIcon material-icons theme--light" onclick="window.open('${urlmapa}', '_blank')">pin_drop</i>`;
  }

  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }

  async btn_exportar() {
    let body: { [key: string]: string } = {
      filtro_tecnico: this.model_filtro_tecnico,
      filtro_patente: this.model_filtro_patente,
      filtro_inicio: this.model_filtro_inicio,
      filtro_fin: this.model_filtro_fin,
      filtro_serie: this.model_filtro_serie,
      filtro_finalizado: this.model_filtro_finalizado,
      filtro_cliente: this.model_filtro_cliente,
    };
    this.loadingService.showLoading(undefined, 'btn_exportar_detalle_completo');
    return fetchMS(
      {
        clienteDefecto: this.getCliente(),
        user_id: this.getUserID(),
        body: body,
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '265',
      },
      'exportar_csv_solicitudes_detalle_completo'
    )
      .then((data: any) => {
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
        }
        this.loadingService.hideLoading('btn_exportar_detalle_completo');
        return data.data;
      })
      .catch((error: any) => {
        this.loadingService.hideLoading('btn_exportar_detalle_completo');
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading('btn_exportar_detalle_completo');
        return null;
      });
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }
  getCliente() {
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }
} //end class
